import './polyfills';
import * as Vue from 'vue';
import moment from 'moment';
import promiseFinally from 'promise.prototype.finally';
import VueDOMPurifyHTML from 'vue-dompurify-html';
import createMetaMixin from 'quasar/src/utils/create-meta-mixin.js';;
import './init';
import './auth/init';
import App from './App.vue';
import router from './router';
import quasar from './quasar';
import './styles/style.scss';
import 'animate.css/animate.min.css';
import errorHandler, { handleVueError } from './error-handling/error-handler';
import { name as clientName } from './client/client-filter';
import { getStatusText } from './social/post/post';
import { Report } from './type';

promiseFinally.shim();


errorHandler();

const filters = {
  date: (date: Date|string) => moment(date).format('MMM DD, YYYY'),
  clientName,
  clientNameFilter: clientName,
  currency: (amount: number) => (amount / 100).toFixed(2),
  keywords: (keywords: string[]) => keywords.join(', '),
  postStatus: (report: Report) => {
    const statuses = report.statuses.map(getStatusText);
    if (report.isOnTimeline) {
      statuses.unshift('Timeline');
    }
    if (report.isFlagged) {
      statuses.push('Flagged');
    }
    return statuses.join(', ');
  },
  datetime: (date: Date|string) => {
    const time = moment(date);
    let timeZone = '';
    const formatter = new Intl.DateTimeFormat('en-US', { timeZoneName: 'short' });
    const parts = formatter.formatToParts(time.toDate());
    const timeZoneName = parts.find(part => part.type === 'timeZoneName');
    if (timeZoneName) {
      timeZone = timeZoneName.value;
    }
    return `${time.format('MMM DD YYYY h:mma')} ${timeZone}`;
  },
};

const app = (Vue as any).createApp(App);

app.config.errorHandler = handleVueError;
app.config.globalProperties.$filters = filters;

app.mixin(createMetaMixin(function resolveMeta() {
  const { meta } = this.$options as any;
  return typeof meta === 'function' ? meta.call(this) : meta || {};
}));

app.use(router);
app.use(quasar.plugin, quasar.options);
app.use(VueDOMPurifyHTML, {
  namedConfigurations: {
    postContent: {
      ALLOWED_TAGS: ['span'],
      ALLOWED_ATTR: ['class'],
    },
  },
});

app.mount('#app');
